import {Component, OnInit} from '@angular/core';

import {AuthenticationService, LoaderService} from "../../services/index";
import * as $ from 'jquery';
import {Router, NavigationStart, NavigationEnd} from "@angular/router";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  user;
  loader = false;
  link;
  printPage = 'fixed';
  display = '';

  constructor(private authentication:AuthenticationService,
              private loaderService:LoaderService,
              private router:Router) {
    router.events.forEach((event) => {
      event instanceof NavigationEnd ?
        this.checkIsPrintPage(event) : null;
    });
  }

  ngOnInit() {
    this.user = this.authentication.user();
  }

  checkIsPrintPage(event) {
    this.printPage = event.urlAfterRedirects.indexOf('print') < 0 ? 'fixed' : '';
    this.display = event.urlAfterRedirects.indexOf('/home') >= 0 ? 'hide' : '';
  }

  toggleSideBar() {
    $('.sidebar').toggleClass('compact');
    $('#page-wrapper').toggleClass('active');
    // $('footer').toggleClass('active');
  }

  setLoader() {
    this.loader = !this.loader;
    this.loaderService.loading(this.loader);
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/navbar/navbar.component.ts